<template>
  <div>
    <el-dialog width="800px"
               :title="titles"
               :visible.sync="viewDetail"
               :close-on-click-modal='false'
               @close="closeModel">
      <div class="table-box">
        <div style="width:500px">
          <el-row :gutter="4"
                  type="flex"
                  style="margin-bottom:20px"
                  align='middle'>
            <el-col :span="3">
              商品ID：
            </el-col>
            <el-col :span="8">
              <el-input v-model="goodsID"
                        @clear='searClear'
                        clearable></el-input>
            </el-col>
            <el-col :span="2">
              <el-button size="small"
                         @click='searcHandle'>搜索</el-button>
            </el-col>
          </el-row>
          <el-table :data="tableData"
                    ref='multipleTable'
                    height="450"
                    v-if="this.titles == '添加商品'"
                    :row-key="getRowKeys"
                    @selection-change="handleSelectionChange">
            <el-table-column prop="id"
                             label="商品ID"
                             width="180">
            </el-table-column>
            <el-table-column prop="tits"
                             label="商品名称">
            </el-table-column>
            <el-table-column width="100"
                             align="center"
                             type="selection"
                             :reserve-selection="true"
                             :selectable="selectable"
                             label-class-name="DisabledSelection">
            </el-table-column>
          </el-table>
          <el-table :data="tableData"
                    v-else
                    ref='multipleTable'
                    height="440"
                        :row-key="getRowKeys1"
                    @selection-change="handleSelectionChange">
            <el-table-column prop="goods_id"
                             label="商品ID"
                             width="180">
            </el-table-column>
            <el-table-column prop="tits"
                             label="商品名称">
            </el-table-column>
            <el-table-column width="100"
                             align="center"
                             type="selection"
                             :selectable="selectable"
                             :reserve-selection="true"
                             label-class-name="DisabledSelection">
            </el-table-column>
          </el-table>
          <div class="pageSize">
            <el-pagination background
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="page"
                           :page-sizes="[10, 20, 30, 40]"
                           :page-size="size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
          </div>
          <div style="text-align:center">
            <el-button size="medium"
                       style="margin-right:100px"
                       @click="cancle">取消</el-button>
            <el-button type="primary"
                       size="medium"
                       v-loading='loading'
                       @click="saveHandle">保 存</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ['tableindex', 'method', 'titles', 'categoodsid', 'goods_id'],
  data () {
    return {
      viewDetail: true,
      goodsID: '',
      selectTable: [],
      allselectList: [],
      total: 0,
      page: 1,
      size: 10,
      tableData: [],
      loading: false,
      changeid: ''
    };
  },
  computed: {
    ...mapGetters({
      getToken: "getToken",
    }),
  },
  mounted () {
    this.initAPI()

  },
  methods: {
    ...mapActions({
      decorateGoodsList: "detect/decorateGoodsList", //列表
      decorateSortCate: "detect/decorateSortCate", //关联列表
      decorateSortCateSave: "detect/decorateSortCateSave", //关联列表-保存
      decorateGoodsAdd: "detect/decorateGoodsAdd", //排序
      decorateSortChange: "detect/decorateSortChange", //编辑-替换

    }),

    getRowKeys(row) {
				return row.id;
			},
    getRowKeys1(row) {
				return row.goods_id;
			},
    closeModel () {
      this.$emit("closeModel");
    },
    initAPI () {
      if (this.titles == '添加商品') {
        this.getdecorateGoodsList()
      } else if (this.titles == '添加关联商品') {
        this.getdecorateSortCate(this.goods_id)
      } else if (this.titles == '编辑关联商品') {
        this.getdecorateSortCate(this.goods_id)
      } else if (this.titles == '替换关联商品') {
        this.getdecorateSortCate(this.goods_id)
      }

    },
    setdecorateSortChange () {
      let params = {
        token: this.getToken,
        shop_id: this.$route.query.id,
        goods_id: this.goods_id,
        goods_ids: this.changeid,
        id: this.categoodsid
      }
      this.decorateSortChange(params).then((res) => {
        if (res.data.code == 1) {
          this.closeModel()
          this.method()
        } else {
          this.$message.error(res.data.msg);
        }
      }
      )
    },
    handleSizeChange (val) {
      this.size = val;
      this.initAPI()
    },
    handleCurrentChange (val) {
      this.page = val;
      this.initAPI()
    },
    searcHandle () {
      this.page = 1
      this.initAPI()
    },
    searClear () {
      this.page = 1
      this.goodsID = ''
      this.getdecorateGoodsList()
    },
    hideHeaderCheckBox (row) {
      if (row.columnIndex === 0) {
        return 'hideHeaderCheckBox'
      }
    },

    handleSelectionChange (val) {
      if (this.titles == '替换关联商品') {
        if (val.length > 1) {
          const del_row = val.shift()
          this.$refs.multipleTable.toggleRowSelection(del_row, false)
        }
        if (val.length) this.changeid = val[0].goods_id

        this.selectTable = val
      } else {
        this.selectTable = val
       
          
      }


    },
    selectable (row, index) {
   
      if ((Number( this.tableindex) + this.selectTable.length) == 10) {
        return false;//禁用状态
      } else {
        return true;//禁用状态
      }
    },
    cancle () {
      this.closeModel()
      this.$refs.multipleTable.clearSelection()
    },
    saveHandle () {
      if (this.titles == '添加关联商品') {
        this.$emit('submitTable', this.selectTable)
        this.closeModel()
      } else {
        if (this.selectTable.length == 0) {
          this.$message.error('请选择推荐商品');
        } else {
          let list = []
          if (this.titles == '添加商品') {
            this.selectTable.forEach(el => {
              list.push(el.id)
            })
            if (list.length > 0) {
              let string = list.join(',')
              this.setdecorateGoodsAdd(string)
            }
          } else {
            if (this.titles == '替换关联商品') {
              console.log(5)
              this.setdecorateSortChange()
            } else {
              this.selectTable.forEach(el => {
                list.push(el.goods_id)
              })
              if (list.length > 0) {
                let string = list.join(',')
                this.setdecorateSortCateSave(string)
              }
            }
          }
        }
      }
    },
    setdecorateSortCateSave (list) {
      this.loading = true
      let params = {
        token: this.getToken,
        shop_id: this.$route.query.id,
        goods_id: list,
      }
      this.decorateSortCateSave(params).then(res => {
        this.loading = false
        if (res.data.code == 1) {
          this.$message.success(res.data.msg);
          this.closeModel()
          this.$emit('submitTable', this.selectTable)
          /*  this.method() */
        } else {
          this.$message.error(res.data.msg);
        }

      })
    },
    //推荐商品
    getdecorateGoodsList () {
      let params = {
        token: this.getToken,
        shop_id: this.$route.query.id,
        goods_id: this.goodsID,
        page: this.page,
        limit: this.size,
        is_recom: 0
      }
      this.decorateGoodsList(params).then(res => {
        if (res.data.code == 1) {
          this.tableData = res.data.data.list
                     this.$nextTick(()=>{
 this.$refs.multipleTable.toggleRowSelection(this.tableData[0],true);
        })
          this.total = parseInt(res.data.data.total)
        } else {
          this.$message.error(res.data.msg);
        }

      })
    },
    //关联商品decorateSortCate
    getdecorateSortCate (goods_id) {
      let params = {
        token: this.getToken,
        shop_id: this.$route.query.id,
        cate_goods_id: this.goodsID,
        page: this.page,
        limit: this.size,
      }
      if (this.titles == '编辑关联商品' || this.titles == '替换关联商品') {
        params.goods_id = goods_id,
          params.id = this.categoodsid
      }
      this.decorateSortCate(params).then(res => {

        if (res.data.code == 1) {
          this.tableData = res.data.data.goods
          this.total = parseInt(res.data.data.total)
                     this.$nextTick(()=>{
 this.$refs.multipleTable.toggleRowSelection(this.tableData[0],true);
        })
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    setdecorateGoodsAdd (list) {
      this.loading = true
      let params = {
        token: this.getToken,
        shop_id: this.$route.query.id,
        goods_id: list,
      }
      this.decorateGoodsAdd(params).then(res => {
        this.loading = false
        if (res.data.code == 1) {
          this.$message.success(res.data.msg);
          this.closeModel()
          this.method()
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    setEdit (list) {
      this.loading = true
      let params = {
        token: this.getToken,
        shop_id: this.$route.query.id,
        goods_id: list,
      }
      this.decorateGoodsAdd(params).then(res => {
        this.loading = false
        if (res.data.code == 1) {
          this.$message.success(res.data.msg);
          this.closeModel()
          this.method()
        } else {
          this.$message.error(res.data.msg);
        }

      })
    },
  },
  components: {

  },
};
</script>

<style scoped lang="scss">
.table-box {
  display: flex;
  justify-content: center;
  /* min-height: 600px; */
}

::v-deep.el-table {
  .DisabledSelection .cell .el-checkbox__inner {
    display: none;
    position: relative;
  }
}

::v-deep .el-table {
  .DisabledSelection {
    .cell:before {
      content: "操作";
      position: absolute;
      right: 35px;
    }
  }
}
::v-deep .el-input--medium .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.pageSize {
  text-align: right;
  margin-top: 20px;
  margin-bottom: 30px;
}
</style>
